export const splunk_log_type = {
  INFO: 'info',
  ERROR: 'error',
  WARN: 'warn',
};

export const splunk_message = {
  SUCCESS: {
    GET_BASE_USER_STARTED: {
      id: 'CDTS_UIVISION_SUCCESS_S10001',
      message: 'Fetching base user details successfully started',
    },
    GET_SAVED_FOR_LATER_CART_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10002',
      message: 'Fetched saved for later cart successfully',
    },
    BUILD_URL_WITH_PARAMS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10003',
      message: 'Successfully built URL with parameters',
    },
    UPDATE_CART_FOR_PRICING_INVOKED: {
      id: 'CDTS_UIVISION_SUCCESS_S10004',
      message: 'Updated cart for pricing invoked',
    },
    GET_CART_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10005',
      message: 'Fetched cart successfully',
    },
    USE_API_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10006',
      message: 'Successfully used the API',
    },
    GET_USER_FAVORITES_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10007',
      message: 'Successfully fetched user favorites',
    },
    GET_BASE_USER_DETAILS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10008',
      message: 'Successfully fetched base user details',
    },
    ADD_TO_CART_INVOKED: {
      id: 'CDTS_UIVISION_SUCCESS_S10009',
      message: 'Add item to cart invoked',
    },
    REMOVE_FROM_CART_INVOKED: {
      id: 'CDTS_UIVISION_SUCCESS_S10010',
      message: 'Remove item from cart invoked',
    },
    ADJUST_ITEM_QTY_IN_CART_INVOKED: {
      id: 'CDTS_UIVISION_SUCCESS_S10011',
      message: 'Adjust item quantity in cart invoked',
    },
    MOVE_CART_ITEM_TO_SAVED_FOR_LATER: {
      id: 'CDTS_UIVISION_SUCCESS_S10012',
      message: 'Move cart item to saved for later invoked',
    },
    GET_SAVINGS_PLAN_INVOKED: {
      id: 'CDTS_UIVISION_SUCCESS_S10013',
      message: 'Get savings plan invoked',
    },
    GET_APPOINTMENT_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10014',
      message: 'Appointment booked successfully',
    },
    FETCH_CONTENT_SUCCESS_IN_CHECKOUT: {
      id: 'CDTS_UIVISION_SUCCESS_S10015',
      message: 'Successfully fetched content',
    },
    ON_CLOSE_CHECKOUT_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10016',
      message: 'Successfully closed the checkout process',
    },
    FETCH_CONTENT_SUCCESS_IN_PAGE_LAYOUT: {
      id: 'CDTS_UIVISION_SUCCESS_S10017',
      message: 'Successfully fetched content in page layout',
    },
    HANDLE_FAVORITE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10018',
      message: 'Successfully handled favorite item',
    },
    FETCH_NOTIFICATION_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10019',
      message: 'Successfully fetched notifications',
    },
    GET_VALIDATE_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10020',
      message: 'Successfully validated address',
    },
    VALIDATE_USER_ENTERED_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10021',
      message: 'Successfully validated user entered address',
    },
    VERIFY_USER_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10022',
      message: 'Successfully verified user address',
    },
    CLOSE_NOTIFICATION_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10023',
      message: 'Notification closed successfully',
    },
    BASE_USER_PROFILE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10024',
      message: 'Successfully fetched base user profile',
    },
    NOTIFICATION_SERVICE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10025',
      message: 'Successfully accessed the notification service',
    },
    GET_BENEFITS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10026',
      message: 'Successfully fetched benefits',
    },
    TOKEN_EXPIRY_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10027',
      message: 'Token expiry handled successfully',
    },
    PRESCRIPTION_BY_ID_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10028',
      message: 'Successfully fetched prescription by ID',
    },
    PRESCRIPTION_LIST_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10029',
      message: 'Successfully fetched prescription list',
    },
    SET_LIVE_SESSION_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10030',
      message: 'Successfully set the live session',
    },
    SET_PD_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10031',
      message: 'Successfully set the PD',
    },
    BENEFIT_REQUEST_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10032',
      message: 'Successfully fetched benefit request',
    },
    GET_LIVE_SESSION_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10033',
      message: 'Successfully retrieved live session',
    },
    ADD_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10034',
      message: 'Successfully added address',
    },
    UPDATE_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10035',
      message: 'Successfully updated address',
    },
    DELETE_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10036',
      message: 'Successfully deleted address',
    },
    ORDER_HISTORY_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10037',
      message: 'Successfully fetched order history',
    },
    CANCEL_ORDER_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10038',
      message: 'Order cancellation successful',
    },
    INVOICE_DATA_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10039',
      message: 'Successfully fetched invoice data',
    },
    SET_DEFAULT_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10040',
      message: 'Successfully set the default address',
    },
    GET_ADDRESS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10041',
      message: 'Successfully fetched address',
    },
    USER_ACCOUNT_DETAILS_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10042',
      message: 'Successfully fetched user account details',
    },
    STORE_LIST_WITH_PRODUCT_AVAILABILITY_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10043',
      message: 'Successfully fetched store list with product availability',
    },
    STORE_LIST_API_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10044',
      message: 'Successfully fetched store list from API',
    },
    SEARCH_SERVICE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10045',
      message: 'Search service executed successfully',
    },
    SAVINGS_PLAN_SERVICE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10046',
      message: 'Successfully accessed the savings plan service',
    },
    GET_PRODUCT_SEARCH_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10047',
      message: 'Successfully fetched product search results',
    },
    PLACE_ORDER_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10048',
      message: 'Order placed successfully',
    },
    MAKEABILITY_SERVICE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10049',
      message: 'Makeability service was successful',
    },
    ADD_FAVORITE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10050',
      message: 'Successfully added item to favorites',
    },
    REMOVE_FAVORITE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10051',
      message: 'Successfully removed item from favorites',
    },
    GET_FAVORITE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10052',
      message: 'Successfully fetched favorite item',
    },
    CONTACT_US_SERVICE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10053',
      message: 'Contact us was successful',
    },
    LOGIN_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10054',
      message: 'User logged in successfully',
    },
    LOGOUT_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10055',
      message: 'User logged out successfully',
    },
    KPD_LOGOUT_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10056',
      message: 'KPD user logged out successfully',
    },
    GET_EXTENDED_USER_STARTED: {
      id: 'CDTS_UIVISION_SUCCESS_S10057',
      message: 'Fetching extended user details successfully started',
    },
    EXTENDED_USER_PROFILE_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10058',
      message: 'Successfully fetched extended user profile',
    },
    SET_EG_PRESCRIPTION: {
      id: 'CDTS_UIVISION_SUCCESS_S10059',
      message: 'Successfully set eyeglass prescription in live session',
    },
    SET_CL_PRESCRIPTION: {
      id: 'CDTS_UIVISION_SUCCESS_S10060',
      message: 'Successfully set contact lens prescription in live session',
    },
    LW_EG_PRESCRIPTION: {
      id: 'CDTS_UIVISION_SUCCESS_S10061',
      message: 'Lens Wizard loaded with eyeglass prescription',
    },
    CHECKOUT_RX_VALIDATION_SUCCESS: {
      id: 'CDTS_UIVISION_SUCCESS_S10062',
      message: 'Checkout prescription validation succeeded',
    },
  },
  ERROR: {
    GET_BASE_USER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20001',
      message: 'Fetching base user details failed',
    },
    GET_SAVED_FOR_LATER_CART_ERROR_API: {
      id: 'CDTS_UIVISION_ERROR_E20002',
      message: 'API Error in getting saved for later cart',
    },
    GET_SAVED_FOR_LATER_CART_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20003',
      message: 'Error in getting saved for later cart',
    },
    GET_SAVED_FOR_LATER_CART_RESPONSE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20004',
      message: 'Response Error in getting saved for later cart',
    },
    GET_SAVED_FOR_LATER_CART_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20005',
      message: 'Data Error in getting saved for later cart',
    },
    ADD_CART_ITEM_SAVE_FOR_LATER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20006',
      message: 'Error in adding item to saved for later cart',
    },
    ADD_CART_ITEM_SAVE_FOR_LATER_ERROR_API: {
      id: 'CDTS_UIVISION_ERROR_E20007',
      message: 'Error API in adding item to saved for later cart',
    },
    ADD_CART_ITEM_SAVE_FOR_LATER_ERROR_RESPONSE: {
      id: 'CDTS_UIVISION_ERROR_E20008',
      message: 'Error REPONSE in adding item to saved for later cart',
    },
    ADD_CART_ITEM_SAVE_FOR_LATER_ERROR_Data: {
      id: 'CDTS_UIVISION_ERROR_E20009',
      message: 'Error DAta in adding item to saved for later cart',
    },
    MOVE_SAVE_FOR_LATER_ITEM_TO_CART_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20010',
      message: 'Error in moving item from saved for later cart to cart',
    },
    MOVE_SAVE_FOR_LATER_ITEM_TO_CART_API_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20011',
      message: 'API Error in moving item from saved for later cart to cart',
    },
    MOVE_SAVE_FOR_LATER_ITEM_TO_CART_RESPONSE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20012',
      message: 'Response Error in moving item from saved for later cart to cart',
    },
    MOVE_SAVE_FOR_LATER_ITEM_TO_CART_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20013',
      message: 'Data Error in moving item from saved for later cart to cart',
    },
    CART_TOTAL_MISMATCH_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20014',
      message: 'Cart total mismatch detected',
    },
    REMOVE_FROM_SAVED_FOR_LATER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20015',
      message: 'Error in removing item from saved for later cart',
    },
    REMOVE_FROM_SAVED_FOR_LATER_API_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20016',
      message: 'API Error in removing item from saved for later cart',
    },
    REMOVE_FROM_SAVED_FOR_LATER_RESPONSE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20017',
      message: 'Response Error in removing item from saved for later cart',
    },
    REMOVE_FROM_SAVED_FOR_LATER_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20018',
      message: 'Data Error in removing item from saved for later cart',
    },
    BUILD_URL_WITH_PARAMS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20019',
      message: 'Error in building URL with parameters',
    },
    GET_CART_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20020',
      message: 'Error in getting cart',
    },
    UPDATE_CART_FOR_PRICING_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20021',
      message: 'Error in updating cart for pricing',
    },
    CART_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20022',
      message: 'Error in cart',
    },
    BENEFITS_REQUEST_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20023',
      message: 'Failed to refresh benefit data',
    },
    FETCH_PROTECTION_SAVINGS_PLAN_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20024',
      message: 'Failed to fetch protection savings plan',
    },
    TRIGGER_CUSTOMER_EVENT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20025',
      message: 'Error in triggering customer event',
    },
    BUILD_ANALYTIC_CLICK_EXTERNAL_URL_CODE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20026',
      message: 'Error in building analytic click external URL code',
    },
    BUILD_ANALYTICS_LOCATIONS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20027',
      message: 'Error in building analytics locations',
    },
    CART_SAVINGS_PLAN_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20028',
      message: 'Error in cart savings plan',
    },
    GET_USER_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20029',
      message: 'Error in getting user address',
    },
    HANDLE_ADDRESS_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20030',
      message: 'Error in handling address service',
    },
    GET_INVOICE_FETCH_CONTENT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20031',
      message: 'Error in getting invoice fetch content',
    },
    FETCH_INVOICE_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20032',
      message: 'Error in fetching invoice data',
    },
    FETCH_PROTECTION_SAVINGS_PLAN_ORDER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20033',
      message: 'Error in fetching protection savings plan data',
    },
    ON_SUBMIT_CANCEL_ORDER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20034',
      message: 'Error in submitting cancel order',
    },
    FETCH_COMMERCE_TOOLS_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20035',
      message: 'Error in fetching commerce tools data',
    },
    SET_INSTORE_COMMERCE_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20036',
      message: 'Error in setting in-store commerce data',
    },
    FETCH_ORDER_HISTORY_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20037',
      message: 'Error in fetching order history data',
    },
    ON_SHOP_RX_HEADER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20038',
      message: 'Error in shopping for RX',
    },
    ON_SHOP_RX_FOOTER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20039',
      message: 'Error in shopping for RX',
    },
    VERIFY_BILLING_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20040',
      message: 'Error in verify billing address function',
    },
    PLACE_ORDER_PAYMENT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20041',
      message: 'Error in place order payment function',
    },
    CHECKOUT_RX_VALIDATION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20062',
      message: 'Checkout prescription validation failed',
    },
    SET_PD_IN_LIVE_SESSION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20042',
      message: 'Error in setPD in livesession ',
    },
    GET_PD_IN_LIVE_SESSION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20043',
      message: 'Error in getPD in livesession ',
    },
    QUERY_PROMOTIONS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20044',
      message: 'Error in query promotions ',
    },
    SUBMIT_CONTACTUS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20045',
      message: 'Error in submitting contact us form',
    },
    GET_CONTACTS_BY_PRODUCT_ID_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20046',
      message: 'Error in fetching contacts by product id',
    },
    GET_CONTACTS_BY_PRODUCT_SKU_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20047',
      message: 'Error in fetching contacts by product sku',
    },
    FETCH_VOLUME_DISCOUNT_FOR_CONTACTS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20048',
      message: 'Error in fetching volume discount',
    },
    INVALID_VOLUME_DISCOUNT_REGION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200113',
      message: 'Invalid region while fetching volume discount',
    },
    MISSING_VOLUME_DISCOUNT_PRODUCT_KEY_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200114',
      message: 'Missing contact lens product key while fetching volume discount',
    },
    FETCH_LENS_WIZARD_CONTENT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20049',
      message: 'Error in fetching lens wizard content',
    },
    GET_REBATES_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20050',
      message: 'Error in fetching rebates',
    },
    GET_REGION_PICKER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20051',
      message: 'Error in fetching region picker data',
    },
    USE_SAVINGS_PLAN_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20052',
      message: 'Error in accessing the savings plan',
    },
    FETCH_TREATMENT_RULES_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20053',
      message: 'Error in fetching treatment rules',
    },
    FETCH_PRODUCT_BASED_ON_LOCATION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20054',
      message: 'Error in fetching product based on location',
    },
    FETCH_GEOCODING_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20055',
      message: 'Error in fetching geocoding data',
    },
    FETCH_STORE_LIST_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20056',
      message: 'Error in fetching store list',
    },
    FETCH_LOCATION_USING_LATLANG_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20057',
      message: 'Error in fetching location using latlang',
    },
    FETCH_CALCULATE_DISTANCE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20058',
      message: 'Error in calculating distance',
    },
    USE_API_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20059',
      message: 'Error in using the API',
    },
    GET_USER_FAVORITES_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20060',
      message: 'Error in fetching user favorites',
    },
    GET_BASE_USER_DETAILS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20061',
      message: 'Error in fetching base user details',
    },
    GET_CONFIGS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20062',
      message: 'Error in fetching configs',
    },
    GQL_COMMERCE_API_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20063',
      message: 'GQL Commerce API call failed',
    },
    USER_AGE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20064',
      message: 'User age verification failed',
    },
    GET_APPOINTMENT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20065',
      message: 'Failed to process your request for appointment booking',
    },
    FETCH_LENS_WIZARD_CONFIG_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20066',
      message: 'Error in fetching lens wizard config',
    },
    INVALID_LENS_WIZARD_CONFIG_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20067',
      message: 'Error in lens wizard config content',
    },
    FETCH_CONTENT_ERROR_IN_CHECKOUT: {
      id: 'CDTS_UIVISION_ERROR_E20068',
      message: 'Error in fetching content',
    },
    ON_CLOSE_CHECKOUT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20069',
      message: 'Error in closing the checkout process',
    },
    FETCH_CONTENT_ERROR_IN_PAGE_LAYOUT: {
      id: 'CDTS_UIVISION_ERROR_E20070',
      message: 'Error in fetching content in page layout',
    },
    HANDLE_FAVORITE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20071',
      message: 'Error in handling favorite item',
    },
    FETCH_NOTIFICATION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20072',
      message: 'Error in fetching notifications',
    },
    GET_VALIDATE_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20073',
      message: 'Error in validating address',
    },
    VALIDATE_USER_ENTERED_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20074',
      message: 'Error in validating user entered address',
    },
    VERIFY_USER_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20075',
      message: 'Error in verifying user address',
    },
    CLOSE_NOTIFICATION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20076',
      message: 'Error in closing notification',
    },
    INVALID_LENS_WIZARD_PAYLOAD_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20077',
      message: 'Mismatch between lens wizard selections and payload content',
    },
    BASE_USER_PROFILE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20078',
      message: 'Error in fetching base user profile',
    },
    NOTIFICATION_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20079',
      message: 'Error in accessing the notification service',
    },
    GET_BENEFITS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20080',
      message: 'Error in fetching benefits',
    },
    TOKEN_EXPIRY_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20081',
      message: 'Error in handling token expiry',
    },
    PRESCRIPTION_BY_ID_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20082',
      message: 'Error in fetching prescription by ID',
    },
    PRESCRIPTION_LIST_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20083',
      message: 'Error in fetching prescription list',
    },
    SET_LIVE_SESSION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20084',
      message: 'Error in setting the live session',
    },
    SET_PD_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20085',
      message: 'Error in setting the PD',
    },
    BENEFIT_REQUEST_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20086',
      message: 'Error in fetching benefit request',
    },
    GET_LIVE_SESSION_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20087',
      message: 'Error in retrieving live session',
    },
    ADD_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20088',
      message: 'Error in adding address',
    },
    UPDATE_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20089',
      message: 'Error in updating address',
    },
    DELETE_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20090',
      message: 'Error in deleting address',
    },
    ORDER_HISTORY_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20091',
      message: 'Error in fetching order history',
    },
    CANCEL_ORDER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20092',
      message: 'Error in order cancellation',
    },
    INVOICE_DATA_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20093',
      message: 'Error in fetching invoice data',
    },
    SET_DEFAULT_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20094',
      message: 'Error in setting the default address',
    },
    GET_ADDRESS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20095',
      message: 'Error in fetching address',
    },
    USER_ACCOUNT_DETAILS_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20096',
      message: 'Error in fetching user account details',
    },
    STORE_LIST_WITH_PRODUCT_AVAILABILITY_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20097',
      message: 'Error in fetching store list with product availability',
    },
    STORE_LIST_API_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20098',
      message: 'Error in fetching store list from API',
    },
    SEARCH_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E20099',
      message: 'Error in executing search service',
    },
    SAVINGS_PLAN_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200100',
      message: 'Error in accessing the savings plan service',
    },
    GET_PRODUCT_SEARCH_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200101',
      message: 'Error in fetching product search results',
    },
    PLACE_ORDER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200102',
      message: 'Error in placing the order',
    },
    MAKEABILITY_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200103',
      message: 'Error in Makeability service',
    },
    ADD_FAVORITE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200104',
      message: 'Error in adding item to favorites',
    },
    REMOVE_FAVORITE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200105',
      message: 'Error in removing item from favorites',
    },
    GET_FAVORITE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200106',
      message: 'Error in fetching favorite item',
    },
    CONTACT_US_SERVICE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200107',
      message: 'Error in Contact Us service',
    },
    LOGIN_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200108',
      message: 'Error in user login process',
    },
    LOGOUT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200109',
      message: 'Error in user logout process',
    },
    KPD_LOGOUT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200110',
      message: 'Error in KPD user logout process',
    },
    GET_EXTENDED_USER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200111',
      message: 'Fetching extended user details failed',
    },
    EXTENDED_USER_PROFILE_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200112',
      message: 'Error in fetching extended user profile',
    },
    LW_INCOMPATIBLE_RX_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200113',
      message: 'All options are incompatible in the current Lens Wizard step',
    },
    GET_ADDRESS_EMPTY_RESPONSE: {
      id: 'CDTS_UIVISION_ERROR_E200114',
      message: 'getAddress returned an empty or null response',
    },
    GET_ADDRESS_GRAPHQL_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200115',
      message: 'getAddress response contained GraphQL errors',
    },
    UPDATE_CART_PD_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200117',
      message: 'Error updating cart PD after re-measurement',
    },
    GET_ADDRESS_INVALID_STRUCTURE: {
      id: 'CDTS_UIVISION_ERROR_E200116',
      message: 'getAddress response has invalid or missing data structure',
    },
    GET_CART_EMPTY_RESPONSE: {
      id: 'CDTS_UIVISION_ERROR_E200117',
      message: 'getCart returned an empty or null response',
    },
    GET_CART_GRAPHQL_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200118',
      message: 'getCart response contained GraphQL errors',
    },
    UPDATE_CART_FOR_PRICING_EMPTY_RESPONSE: {
      id: 'CDTS_UIVISION_ERROR_E200119',
      message: 'updateCartForPricing returned an empty or null response',
    },
    UPDATE_CART_FOR_PRICING_GRAPHQL_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200120',
      message: 'updateCartForPricing response contained GraphQL errors',
    },
    TOKEN_EXPIRY_EMPTY_RESPONSE: {
      id: 'CDTS_UIVISION_ERROR_E200121',
      message: 'getTokenExpiry returned an empty or null response',
    },
    TOKEN_EXPIRY_GRAPHQL_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200122',
      message: 'getTokenExpiry response contained GraphQL errors',
    },
    TOKEN_EXPIRY_INVALID_VALUE: {
      id: 'CDTS_UIVISION_ERROR_E200123',
      message: 'getTokenExpiry returned an invalid expiresIn value',
    },
    CLIENT_ERROR_BOUNDARY_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200124',
      message: 'Unhandled client error captured by error boundary',
    },
    INVALID_PAYMENT_SELECTION: {
      id: 'CDTS_UIVISION_ERROR_E200125',
      message: 'Received invalid payment selection event',
    },
    BENEFIT_SYNC_TIMEOUT_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200126',
      message: 'Benefit sync polling timed out while still out of sync',
    },
    PENDING_CLSP_ORDER_ERROR: {
      id: 'CDTS_UIVISION_ERROR_E200127',
      message: 'Error occurred while checking for pending CLSP order',
    },
  },
  WARN: {
    ADOBE_LAUNCH_BLOCKED: {
      id: 'CDTS_UIVISION_WARN_W10001',
      message: 'Adobe Launch blocked or not loaded or kpCustomEvent function is not available',
    },
  },
};
